import CardView from "./view";
import { globalStyles, noop } from "@client/shared/constants";
const NotificationCard = ({
  areAllSelected = false,
  notification = {},
  onCardClick = noop,
  onMoreActionsChange = noop,
  onSelectionChange = noop,
  onToggle = noop,
  selectedRows = [],
}) => {
  return (
    <>
      <CardView
        notification={notification}
        areAllSelected={areAllSelected}
        onCardClick={onCardClick}
        onSelectionChange={onSelectionChange}
        onToggle={onToggle}
        onMoreActionsChange={onMoreActionsChange}
        selectedRows={selectedRows}
      />
    </>
  );
};

export default NotificationCard;
